import React from 'react';
import { Box, Chip, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../0_layout/Footer';
import { Header } from '../0_layout/HeaderFooter';
import { StButton } from '../0_microelements/A4_StButton';

const ArchivePage = () => {
  const navigate = useNavigate();

  const eventStyles = (type) => ({
    width: { lg: '210px', sm: '90%', xs: '230px' },
    margin: 0.5,
    height: { lg: '200px', sm: '150px', xs: '150px' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: 2,
    borderRadius: 2,
    textAlign: 'center',
    fontSize: '16px',
    color: 'gray',

    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'scale(1.08)',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.3)',
    },
  });

  return (
    <>
      <Header />

      <Box
        sx={{
          fontSize: '18px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          pt: { xs: 12, md: 16 },
          minHeight: '100vh',
        }}
      >
        <Box
          sx={{
            width: '80%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
            padding: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, textAlign: 'center' }}>
            ARCHIVED EVENTS
          </Typography>

          <Box
            sx={{
              margin: 3,
              marginBottom: { sm: 13, xs: 13, lg: 3, md: 3 },
              display: 'flex',
              width: '90%',
              height: 'auto',
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', sm: 'column', lg: 'row', md: 'row' },
              alignItems: 'center',

            }}
          >
            <Box
              sx={{ ...eventStyles('SSW'), backgroundColor: '#ffebee' }}
              onClick={() => navigate(`/archive/SSW`)}
            >
              Super Sunday <br /> Workshop
            </Box>

            <Box
              sx={{ ...eventStyles('CSG'), backgroundColor: '#a5d6a7' }}
              onClick={() => navigate(`/archive/CSG`)}
            >
              CS Gems
            </Box>
            <Box
  sx={{ ...eventStyles('SSL'), backgroundColor: '#d1c4e9' }}
  onClick={() => navigate(`/archive/SSL`)}
>
  Super School <br /> Leadership
</Box>


            <Box
              sx={{ ...eventStyles('NCOJ'), backgroundColor: '#ffe082' }}
              onClick={() => navigate(`/archive/NCOJ`)}
            >
              National Coding <br /> Olympiad Junior
            </Box>

            <Box
              sx={{ ...eventStyles('CSAW'), backgroundColor: '#e0f7fa' }}
              onClick={() => navigate(`/archive/CSAW`)}
            >
              C-SAW - Computer <br /> Science Teachers' <br /> Conclave
            </Box>
          </Box>


        </Box>
      </Box>

      <Box sx={{ my: 5 }}>
        <Divider>
          <Chip label="Current Events" />
        </Divider>

        <Box sx={{ textAlign: "center", my: 5 }}> <StButton text="Go to Current Events" hit="/events" /> </Box>
      </Box>



      <Footer />
    </>
  );
};

export default ArchivePage;
